// extracted by mini-css-extract-plugin
export default {"SidebarButton":"SidebarButton_SidebarButton__QV2B4","currentPage":"SidebarButton_currentPage__0hAnX","darkMode":"SidebarButton_darkMode__i-NyA"};